import {
  FETCHED_BALANCE,
  FETCHED_NRG,
  FETCHED_EMB,
  FETCHED_LEMB,

  FETCHED_DAI,
  FETCHED_BTC,
  FETCHED_ETH,
  FETCHED_NEO,
  FETCHED_WAV,
  FETCHED_LSK,

  FETCHED_BLAKE,

  WALLET_SET,
  REMOVE_ASSET,
  REMOVE_WALLET,
  FETCHED_FEE,

  FETCHED_SPENDABLE_OUTPOINTS
} from '../actions/types';

let wallet = JSON.parse(window.localStorage.getItem('bc-wallet'))

let initialState = {
  btc: 0,
  neo: 0,
  wav: 0,
  lsk: 0,
  eth: 0,
  fee: 0.1,
  emb: 0,
  'l-emb':0,
  usdt: 0,
  dai: 0,
  unlockable:0,
  nrg: 0,
  nrg_collateralized: 0,
  spendableOutpoints: [],
  blake : wallet && wallet.emb && wallet.emb.blake ? wallet.emb.blake : null,
  wallet: wallet ? wallet : {},
};

export default function(state: Object = initialState, action) {
  switch (action.type) {
    case FETCHED_FEE:
      return { ...state, fee: action.payload}
    case FETCHED_BALANCE:
      let newstate = state;
      newstate[action.payload.asset] = action.payload.balance;
      return { ...newstate}
    case FETCHED_NRG:
      return { ...state, nrg: action.payload.nrg,nrg_collateralized:action.payload.nrg_collateralized,unlockable:action.payload.unlockable};
    case FETCHED_BTC:
      return { ...state, btc: Math.max(0,action.payload)};
    case FETCHED_NEO:
      return { ...state, neo: action.payload};
    case FETCHED_WAV:
      return { ...state, wav: action.payload};
    case FETCHED_LSK:
      return { ...state, lsk: action.payload};
    case FETCHED_DAI:
      return { ...state, dai: action.payload};
    case FETCHED_ETH:
      return { ...state, eth: action.payload};
    case FETCHED_EMB:
      return { ...state, emb: action.payload.emb};
    case FETCHED_LEMB:
      return { ...state, 'l-emb': action.payload.emb};
    case FETCHED_SPENDABLE_OUTPOINTS:
      return {...state, spendableOutpoints: action.payload}
    case FETCHED_BLAKE:
      let wallet = state.wallet;
      wallet.emb.blake = action.payload;
      if(wallet.emb.blake.substring(0,2) !== "0x") wallet.emb.blake = "0x" + wallet.emb.blake;
      window.localStorage.setItem("bc-wallet", JSON.stringify(wallet));
      return {...state, blake: '0x'+action.payload};
    case WALLET_SET:
      window.localStorage.setItem('bc-wallet',JSON.stringify(action.payload));
      return {...state, wallet: action.payload};
    case REMOVE_WALLET:
      window.localStorage.setItem('bc-wallet',null);
      return {...state, wallet: {}, pendingTransactions: {},nrg:0,nrg_collateralized:0,btc:0,eth:0,emb:0,total_emb:0,lsk:0,neo:0,wav:0};
    case REMOVE_ASSET:
      newstate = state;
      newstate[action.payload] = 0
      return {...newstate}
    default:
      return state;
  }
}
